// extracted by mini-css-extract-plugin
module.exports = {"base":"ZipCodeFormBox-module-base","zipCodeField":"ZipCodeFormBox-module-zip-code-field","box":"ZipCodeFormBox-module-box","headline":"ZipCodeFormBox-module-headline"};